import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SignUpProvider } from '../../providers/sign-up/sign-up'
import { ToastProvider } from '../../providers/toast/toast';
import { SignUpFormPage } from '../sign-up-form/sign-up-form';
import {  ViewController} from 'ionic-angular/navigation/view-controller';



/**
 * Generated class for the SignUpOtpPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */



@IonicPage()
@Component({
	selector: 'page-sign-up-otp',
	templateUrl: 'sign-up-otp.html',
})
export class SignUpOtpPage {
	signUpDetail = []
	public timer = 59;
	public m = 9;
	otpDetails: any;
	userDetails : any;
	loader = false;
	timerOtp = true
	otpDetailsData : any;

	data = {}
	constructor(public navCtrl: NavController,
		public navParams: NavParams,
		private viewCtrl: ViewController,
		private signUpProvider: SignUpProvider,
		private toast: ToastProvider,
		) {
		this.data = {
			background: '/assets/images/background/26.jpg'
		}
		this.userDetails = JSON.parse(localStorage.getItem('signup_user_data'));
		this.otpDetails = this.navParams.get("otpDetails");//only 
		this.start();
	}
	start() {
		var IntervalVar = setInterval(function () {
			this.timer--;
			if (this.timer === 0) {
				this.timer = 60;
				this.m -= 1;
			}
			if (this.m === 0) {
				this.timer = "00";
				this.m = "00"
				clearInterval(IntervalVar);
				this.goToBack()
			}
		}.bind(this), 1000)
	}

	submitForm(data) {
		this.loader = true
		if (data['otp'] == undefined) {
			this.toast.presentToast("Please Enter OTP.");
			return true;
		}
		data = {
			'id' : this.otpDetails.id,
			"otp" : data.otp
		}
		this.signUpProvider.verifyOtp(data).then(val => {
			this.loader = false
			if(val.status == 'success'){
				localStorage.setItem('signup_token',val.data.token ); 
				this.navCtrl.push(SignUpFormPage,{})
			}else{
				this.toast.presentToast("Please Enter Valid OTP");
			}
		})
	}

	

	reSendOtp(){
		this.loader =true

		var data= {
			'id' : this.otpDetails.id,
		}
		this.signUpProvider.resendOtp(data).then((val) =>{
			this.loader = false
			this.toast.presentToast(val.message)
	
	if(val.data == 'success'){
		this.start();
		this.timerOtp = true
	}
 
		})
	}

	goToBack() {
		this.viewCtrl.dismiss();

	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad SignUpOtpPage');
	}

}



// WEBPACK FOOTER //
// ./src/pages/sign-up-otp/sign-up-otp.ts